export const experienceData = [
    {
        id: 1,
        company: 'Fairshare IT Services Pvt. Ltd.',
        jobtitle: 'Web Developer Intern',
        startYear: 'May 2025',
        endYear: 'Present',
        details: [
            'Improved React.js app load performance by 25% via API tuning & lazy loading.',
            'Produced 10+ reusable UI component modules cutting delivery times by 30%.',
            'Closed 20+ defects and shipped 5 production features across bi-weekly sprints.'
        ]
    },
    {
        id: 2,
        company: 'Self-Directed Freelance',
        jobtitle: 'Full Stack Developer',
        startYear: 'Oct 2023',
        endYear: 'Apr 2025',
        details: [
            'Engineered 4 full-stack projects independently using MERN, Rails, & Firebase.',
            'Earned Microsoft Azure Fundamentals (AZ-900) cloud certification.'
        ]
    },
    {
        id: 3,
        company: 'Trainity',
        jobtitle: 'Data Analyst Intern',
        startYear: 'Jun 2023',
        endYear: 'Sep 2023',
        details: [
            'Delivered 8 data projects using SQL/Excel; standardized data-cleaning pipelines.',
            'Published 3 KPI dashboards replacing manual weekly reporting for 5+ stakeholders.'
        ]
    }
];
